import { FormControl as ChakraFormControl, FormControlProps as ChakraFormControlProps } from '@chakra-ui/react';

const FormControl = ({ children, ...props }: ChakraFormControlProps) => (
  <ChakraFormControl {...props}>{children}</ChakraFormControl>
);

export { FormControl };
